import { useRouter } from 'next/router';

export const IS_CHOOSE_YOUR_COVER = 'isChooseYourCover';

const useIsFromChooseYourCover = () => {
  const router = useRouter();
  return Boolean(router.query[IS_CHOOSE_YOUR_COVER]);
};

export default useIsFromChooseYourCover;
